import { css } from 'styled-components';

export const bold = css`
  font-weight: bold;
`;
